import type { Product } from '../../../data/product';
import { compare } from '../../../helpers/column-sort';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

export const Size: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'Size',
  minWidth: 60,
  accessorFn: (product) => product.size,
  toCSV: (product) => ({
    Size: product.size,
    'Size (oz)': product.size_ounces.toFixed(2),
  }),
  sortingFn: (rowA, rowB) => compare(rowA.size_ounces, rowB.size_ounces),
});
